import React from 'react'
import './componentsCss/DataCard.css'
function DataCard({ numTitle, infoTitle, style, icon }) {

    return (
        <>
            <div style={style} className='data-card '>
                <h6 className='item-svg'>{infoTitle}</h6>

                <h1 style={{ marginBottom: 0, marginTop:20 }}>{numTitle.toLocaleString('pt-BR', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                })}
                </h1>
            </div>
        </>
    )
}

export default DataCard;